import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const TestingConnectionPhase = memo(function TestingConnectionPhase({
  disabled,
  userId,
  progressIcon,
  successIcon,
  errorIcon,
}: TestingConnectionProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {progressIcon ? <CircularProgress size="24px" sx={{ mr: 1 }} /> : null}
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        {errorIcon ? (
          <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">Connecting #{userId}...</Typography>
      </Box>

      <Stack sx={{ mt: 2 }} spacing={1} direction="column">
        <Typography variant="body1">
          The CloudFormation template sets an IAM role up, and we hand it to
          code that handles some more complicated steps. One of the most
          important benefits is that we can better communicate the process to
          you.
        </Typography>

        <Typography variant="body1">
          Unless an error occurs, the steps below will progress automatically.
        </Typography>
      </Stack>
    </ServiceConnectionStep>
  );
});

export default TestingConnectionPhase;

// -----------------------------------------------------------------------------

interface TestingConnectionProps {
  disabled: boolean;
  userId: number;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
